var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 56,
    viewBox: "0 0 156 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a123{fill:#338dc8;font-size:48px;font-family:Raleway-ExtraBold,\n            Raleway;font-weight:800;letter-spacing:-0.142em;}\n            .bc123{letter-spacing:-0.113em;}\n            .c123{fill:#333;font-size:13px;font-family:Raleway-Bold,\n            Raleway;font-weight:700;letter-spacing:-0.026em;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-290 -4)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "a123 pae-logo",
    transform: "translate(322 49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -35.208,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "bc123",
    y: 0
  }, "AE")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo-mini.faece7f9.svg";
export { ForwardRef as ReactComponent };